// =============================================================================
// Constants
// =============================================================================

export const DEFAULT_COUNTRY = "Brasil";
export const MAX_INVITES = 5;
export const MAX_POST_LENGTH = 500;
export const MAX_BIO_LENGTH = 500;
export const MAX_USERNAME_LENGTH = 30;
export const MAX_DISPLAY_NAME_LENGTH = 100;
